// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0500a83e","40":"d5ecca99","172":"9deb46e2","224":"f5dc93ea","340":"21478980","464":"5432b987","512":"3f1b8535","700":"31da02ed","728":"7c5cde7d","856":"f2c89fb0","864":"f30cbfc8","928":"db8ac3c2","952":"c80efef3"}[chunkId] + ".chunk.js";
};